import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { chevronLeft } from 'react-icons-kit/typicons/chevronLeft';
import { chevronRight } from 'react-icons-kit/typicons/chevronRight'
import Grid from '@material-ui/core/Grid';

import Button from 'components/Button/Button';
import Header from 'components/Header/Header';
import TreeIndex from 'components/TreeIndex/TreeIndex';
import IndexContent from 'components/IndexContent/IndexContent';
import LocalStorage from 'utils/LocalStorage';

import magnifyOn from '../../static/img/magnify_on.svg';
import magnifyOff from '../../static/img/magnify_off.svg';
import './HelpLayout.css';

declare var HELP_DATA_ES;
declare var HELP_DATA_EN;

class HelpLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: LocalStorage.getString('language') === 'en' && typeof HELP_DATA_EN !== 'undefined' ? HELP_DATA_EN[0] : HELP_DATA_ES[0],
      data: LocalStorage.getString('language') === 'en' && typeof HELP_DATA_EN !== 'undefined' ? HELP_DATA_EN : HELP_DATA_ES,
      sidebarOpen: true
    };
  }

  componentDidMount() {
    const { node } = this.props;
    if (node !== undefined) {
      this.goToNode(node);
    }
    window.addEventListener('load', this.addZoomAction);
  }

  componentDidUpdate() {
    this.addZoomAction();
  }

  changeSelected = (newSelected) => {
    this.setState({ selected: newSelected });
    document.getElementsByClassName('help-content')[0].scroll(0, 0)
  }

  addZoomAction = () => {
    const lstImg = document.querySelectorAll('.ic-content-magnify');
    let lstBtn, btn;
    if (lstImg && lstImg.length > 0) {
      lstImg.forEach(img => {
        lstBtn = img.parentElement.querySelectorAll('.btnMagnify');
        if (lstBtn && lstBtn.length > 0) {
          // Execute onClick when #magnifyOn exists (the zoom event is working...)
          // onClick -> this.removeZoom
          lstBtn.forEach(b => { if (b.querySelector('#magnifyOn')) { b.click() } });
        } else {
          btn = document.createElement('button');
          btn.className = 'btnMagnify';
          const icon = document.createElement('img');
          icon.src = magnifyOn;
          icon.className = 'magnifyOn';
          icon.id = 'magnifyOff';
          btn.appendChild(icon);
          btn.addEventListener('click', this.applyZoom);
          img.parentElement.insertBefore(btn, img);
        }
      });
    }
  }

  removeZoom = (e) => {
    let btn, imgZoomed, parent, icon;

    btn = e.currentTarget;
    icon = btn.querySelector('.magnifyOn');
    parent = btn.parentElement;
    imgZoomed = parent.querySelector('.ic-content-magnifyed');

    parent.removeEventListener("mousemove", this.moveMagnifier);
    btn.removeEventListener('click', this.removeZoom);
    icon.src = magnifyOn;
    icon.id = 'magnifyOff';
    btn.addEventListener('click', this.applyZoom);
    parent.removeChild(imgZoomed);
  }

  // Apply the zoom
  applyZoom = (e) => {
    var zoom = 2;
    let img, imgZoomed, parent, btn, icon;

    btn = e.currentTarget;
    icon = btn.querySelector('.magnifyOn');
    parent = btn.parentElement;
    img = parent.querySelector('.ic-content-magnify');
    imgZoomed = document.createElement('div');
    imgZoomed.className = "ic-content-magnifyed";
    // copy the bw of the original img
    imgZoomed.style.background = 'url("' + img.src + '") no-repeat';
    imgZoomed.style.backgroundSize = (img.width * zoom) + 'px ' + (img.height * zoom) + 'px';
    imgZoomed.style.backgroundColor = 'white';
    imgZoomed.style.display = 'none';

    parent.appendChild(imgZoomed);

    /*execute a function when someone moves the magnifier glass over the image:*/
    parent.addEventListener("mousemove", this.moveMagnifier);
    icon.src = magnifyOff;
    icon.id = 'magnifyOn';
    btn.removeEventListener('click', this.applyZoom);
    btn.addEventListener('click', this.removeZoom);
  }

  moveMagnifier = (e) => {
    const zoom = 2;
    let pos, x, y;
    let w, h, bw;
    let parent, img, imgZoomed;

    parent = e.currentTarget;
    img = parent.querySelector('.ic-content-magnify');
    imgZoomed = parent.querySelector('.ic-content-magnifyed');
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();

    // offsets width and height of the img zoomed (new div)
    w = imgZoomed.offsetWidth / 2;
    h = imgZoomed.offsetHeight / 2;
    bw = 3;

    /*get the cursor's x and y positions:*/
    pos = this.getCursorPos({ x: e.pageX, y: e.pageY }, img);
    x = pos.x;
    y = pos.y;

    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x < parseFloat(getComputedStyle(img).width) &&
      y < parseFloat(getComputedStyle(img).height) &&
      x > 0 && y > 0) {
      imgZoomed.style.display = "";
      /*set the position of the magnifier glass:*/
      var px = (e.pageX - window.pageXOffset - (parseFloat(getComputedStyle(imgZoomed).width) / 2));
      var py = (e.pageY - window.pageYOffset - (parseFloat(getComputedStyle(imgZoomed).height) / 2));

      imgZoomed.style.left = px + "px";
      imgZoomed.style.top = py + "px";
      imgZoomed.style.backgroundPosition = (-1 * ((x * zoom) - w + bw)) + "px " + (-1 * ((y * zoom) - h + bw)) + "px";
    } else {
      imgZoomed.style.display = "none";
    }
  }

  getCursorPos = (e, img) => {
    let x = 0;
    let y = 0;
    // get X and Y of the original image
    const imgPos = img.getBoundingClientRect();

    // calculate the cursor's X and Y, relative to the image
    x = e.x - imgPos.left;
    y = e.y - imgPos.top;

    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }

  goToNode = (node) => {
    const nodes = this.state.data;
    let selected = this.state.selected;
    nodes.forEach((n) => {
      if (n.id === node) {
        selected = n;
      } else if (n.children !== undefined && n.children.length > 0) {
        n.children.forEach((c) => {
          if (c.id === node) {
            selected = c;
          } else if (c.children !== undefined && c.children.length > 0) {
            c.children.forEach((gc) => {
              if (gc.id === node) {
                selected = gc;
              }
            });
          }
        });
      }
    });

    this.changeSelected(selected);
  }

  toggleSidebar = () => {
    const { sidebarOpen } = this.state;
    this.setState({ sidebarOpen: !sidebarOpen });
    this.addZoomAction();
  }

  render() {
    const { selected, sidebarOpen } = this.state;
    return (
      <div className='content-wrapper'>
        <Header />
        <section className='layout-wrapper'>
          <Grid container>
            <Grid item className={`help-menu ${sidebarOpen ? 'active' : ''}`} xs={12} sm={6} md={5} lg={3}>
              <TreeIndex data={this.state.data} changeSelected={this.changeSelected} />
            </Grid>
            <Grid item className={`help-content ${sidebarOpen ? '' : 'help-content-maximized'}`} xs={12} sm={6} md={7} lg={9}>
              <Button className={'toggleSidebar'} id='toggleSidebar' text={<Icon size={'28px'} icon={sidebarOpen ? chevronLeft : chevronRight} />} active={true} onClick={this.toggleSidebar} />
              <IndexContent data={selected} goToNode={this.goToNode} />
            </Grid>
          </Grid>
        </section>
      </div>
    );
  }
}

export default translate()(HelpLayout);